import {TextFieldProps} from '../index';
import {useTheme, TextField, styled, useMediaQuery} from '@mui/material';

// const Component = styled(TextField)<TextFieldProps>(props => ());

export default (props: TextFieldProps) => {
  const styles: any = props.sx ?? {};
  const isAppIIM = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const mandatoryStyles = {
    borderRadius: '100px',
    borderColor: '#7E7E7E33',
    // background: props.placeholder ? '#F8F8F8' : 'unset',
    ':hover fieldset, &.Mui-focused fieldset': {
      borderColor: '#7E7E7E',
      borderWidth: !props.hirist || useMediaQuery('(max-width: 500px)') ? 1 : 0,
    },
  };
  return (
    <TextField
      {...props}
      variant="outlined"
      sx={{
        width: '100%',
        ...styles,
        // margin: props.theme.spacing(1.5, 0),
        '.MuiInputBase-root': {
          ...mandatoryStyles,
          ...styles['.MuiInputBase-root'],
        },
        fieldset: {
          borderColor:
          !props.hirist || useMediaQuery('(max-width: 500px)')
              ? '#7E7E7E33'
              : 'transparent',
        },
      }}
    />
  );
};
